import {ModulesTabs} from './ModulesTabs';
export default ModulesTabs;
